import {ModalCopy_CurrentStep, ModalCopy_Type} from "../@const"
import Task from "../../../model2/task/task"
import {ModalCopy_Task_CopyOptionId} from "../components/copy-task/copy-task"
import {Copy_Manager} from "./manager"
import {ModalCopy_Params} from "../@types"

// const debug = "CopyTasks_Manager"
const debug = false

export class CopyTasks_Manager extends Copy_Manager {

    public tasksToCopy           : Task[]

    constructor(tasks: Task[], params?: ModalCopy_Params) {
        super(ModalCopy_Type.TASKS)
        this.tasksToCopy     = tasks

    }

    init = async () => {
        // const response = await gd.api.Task.getSubtasks(this.tasksToCopy!.id).promise()
        // this.subTasks = response.subTasks
        //
        this.setCurrentStep(ModalCopy_CurrentStep.COPY_TASKS)
    }

    get modalTitle():string {
        return 'Duplicate Tasks'
    }

    get showProjectAccess() {
        return true
    }

    get affectedTasksIds(): ID[] {
        return _.map(this.tasksToCopy, (task:Task)=>{
            return task.id
        })
    }

    async commitCopy(result: any) {
        if (result) this.result = result

        const toProjectId: ID         = this.result.parentProject

        const data: any = {
            titlePostfix        : this.result.titlePostfix,
            copyDescription     : this.result.copyOptions.includes(ModalCopy_Task_CopyOptionId.DESCRIPTION),
            copyTags            : this.result.copyOptions.includes(ModalCopy_Task_CopyOptionId.TAGS),
            copyNotes           : this.result.copyOptions.includes(ModalCopy_Task_CopyOptionId.NOTES),
            copyCustomFields    : this.result.copyOptions.includes(ModalCopy_Task_CopyOptionId.CUSTOM_FIELDS),
            copyUsers           : this.result.copyOptions.includes(ModalCopy_Task_CopyOptionId.USERS),
            copyAssignee        : this.result.copyOptions.includes(ModalCopy_Task_CopyOptionId.ASSIGNEE),
        }


        const request = gd.api.BulkActions.copyTasksToProject(this.affectedTasksIds, toProjectId, data)

        request.done((response: any)=>{

            this.onCopy?.()
            gd.modal.hide()

        })
    }
}